/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-category.reducer';

export const LabTestCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestCategoryEntity = useAppSelector(state => state.labTestCategory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestCategoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestCategory.detail.title">LabTestCategory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.description">Description</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.description}</dd>
          <dt>
            <span id="displayKey">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.displayKey">Display Key</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.displayKey}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.lastupdated}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.name">Name</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.name}</dd>
          <dt>
            <span id="tmSample">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.tmSample">Tm Sample</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.tmSample}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.sortOrder}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestCategory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-category" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-category/${labTestCategoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestCategoryDetail;
